import React, { useCallback, useEffect, useState } from "react";
import TransitionContainer from "./TransitionContainer";
import LoadingSpinner from "./LoadingSpinner";

interface DynamicImageProps {
  src?: string | null;
  alt?: string;
  parentId?: string;
}

const DynamicImage = ({
  src,
  alt = "Loading Image...",
  parentId = "DynamicImageParent",
}: DynamicImageProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const calculateAspectRatioFit = useCallback(
    (
      srcWidth: number,
      srcHeight: number,
      maxWidth: number,
      maxHeight: number
    ) => {
      var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
      return { width: srcWidth * ratio, height: srcHeight * ratio };
    },
    []
  );
  useEffect(() => {
    const img = new Image();
    img.src = src || "";
    img.onload = () => {
      const container = document.getElementById(parentId);
      const maxWidth = container ? container.offsetWidth : window.innerWidth;
      const maxHeight = container ? container.offsetHeight : window.innerHeight;
      const { width, height } = calculateAspectRatioFit(
        img.width,
        img.height,
        maxWidth,
        maxHeight
      );
      setImageSize({ width, height });
      setIsMounted(true);
    };
    // respond to window resize
    const handleResize = () => {
      const container = document.getElementById(parentId);
      if (src && container) {
        const { width, height } = calculateAspectRatioFit(
          img.width,
          img.height,
          container.offsetWidth,
          container.offsetHeight
        );
        setImageSize({ width, height });
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [calculateAspectRatioFit, setImageSize, src, parentId]);
  return (
    <TransitionContainer
      initiallyVisible={false}
      transitionTrigger={src || ""}
      duration={1.0}
    >
      {isMounted ? (
        <img
          src={src || ""}
          alt={alt}
          style={{
            width: imageSize.width,
            height: imageSize.height,
            border: "5px solid white",
            borderRadius: "10px",
            overflow: "clip",
          }}
        />
      ) : (
        <LoadingSpinner asOverlay={false} />
      )}
    </TransitionContainer>
  );
};

export default DynamicImage;
